import React from 'react';
import { Check } from 'lucide-react';

const grupos = [
  {
    titulo: 'Para los colaboradores',
    items: [
      'Mayor bienestar y satisfacción.',
      'Mejores hábitos de autocuidado.',
      'Herramientas prácticas para la vida diaria.',
    ],
  },
  {
    titulo: 'Para la empresa',
    items: [
      'Fortalecimiento de la cultura organizacional.',
      'Mejora del clima laboral.',
      'Diferenciación como empleador.',
    ],
  },
];

const Beneficios = () => {
  return (
    <section id="beneficios" className="section section-cafe">
      <div className="container">
        <div className="text-center mb-12 max-w-2xl mx-auto">
          <h2 className="heading-2">
            Impacto en las personas <em>y en la organización</em>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {grupos.map((grupo) => (
            <div
              key={grupo.titulo}
              className="bg-white rounded-2xl p-8 border border-[rgba(7,84,47,0.1)]"
            >
              <h3 className="heading-3 mb-6">{grupo.titulo}</h3>
              <div className="space-y-4">
                {grupo.items.map((item) => (
                  <div key={item} className="check-item">
                    <span className="check-icon">
                      <Check className="w-4 h-4" />
                    </span>
                    <p className="body-medium" style={{ color: 'var(--tinta)' }}>
                      {item}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Beneficios;
